export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_19.f8da6b8c.jpg";